// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__F5U1n","info":"UpdateTermsInfo_info__1dHrf"};